import { Injector } from '@angular/core';
import { Components } from '@formio/angular';
import { FormioCustomComponentInfo, registerExternalCustomFormioComponents } from '@pics-core/dynamic';
import { SupportingDocumentGridComponent } from './supporting-document-grid.component';

const editForm = Components.components.datagrid.editForm();
editForm.components[0].components.push(
  {
    label: 'Document Configuration',
    key: 'document_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Read Only Condition',
        applyMaskOn: 'change',
        autoExpand: false,
        tableView: true,
        key: 'customOptions.readOnlyCondition',
        type: 'textarea',
        placeholder: 'Example: return data.action === \'view\';',
        rows: 4,
        input: true
      }
    ]
  },
  {
    label: 'Upload Validation',
    key: 'upload_validation_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Allowed Extensions',
        key: 'customOptions.allowedExtensions',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'pdf,jpg,jpeg,png'
      },
      {
        label: 'Max File Size Mb',
        key: 'customOptions.maxFileSizeMb',
        type: 'number',
        input: true,
        tableView: true,
        defaultValue: 15
      },
      {
        label: 'File Required Message',
        key: 'customOptions.fileRequiredMessage',
        type: 'textfield',
        input: true,
        tableView: true
      },
      {
        label: 'Category Required Message',
        key: 'customOptions.categoryRequiredMessage',
        type: 'textfield',
        input: true,
        tableView: true
      },
      {
        label: 'Type Required Message',
        key: 'customOptions.typeRequiredMessage',
        type: 'textfield',
        input: true,
        tableView: true
      },
      {
        label: 'Invalid Type Message',
        key: 'customOptions.invalidTypeMessage',
        type: 'textfield',
        input: true,
        tableView: true
      },
      {
        label: 'Max Size Message',
        key: 'customOptions.maxSizeMessage',
        type: 'textfield',
        input: true,
        tableView: true
      }
    ]
  },
  {
    label: 'Archive And Duplicate',
    key: 'archive_duplicate_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Archive Enabled Expression',
        applyMaskOn: 'change',
        key: 'customOptions.archiveEnabledExpression',
        tableView: true,
        type: 'textarea',
        placeholder: 'Example: features.showArchive = data.showarchive === true; return features.showArchive;',
        rows: 4,
        input: true
      },
      {
        label: 'Archived Statuses',
        key: 'customOptions.archivedStatuses',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Archived,Replaced'
      },
      {
        label: 'Duplicate Match On',
        key: 'customOptions.duplicateMatchOn',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'fileName,category,docType,sectionName'
      },
      {
        label: 'Duplicate Allow Override Expression',
        applyMaskOn: 'change',
        key: 'customOptions.duplicateAllowOverrideExpression',
        tableView: true,
        type: 'textarea',
        placeholder: 'Example: return user.roleId === 10;',
        rows: 4,
        input: true
      },
      {
        label: 'Duplicate Block Message For Staff',
        key: 'customOptions.duplicateBlockMessageStaff',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 3
      },
      {
        label: 'Duplicate Block Message For Applicant',
        key: 'customOptions.duplicateBlockMessageApplicant',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 3
      }
    ]
  },
  {
    label: 'Action Expressions',
    key: 'action_expression_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Upload Action Expression',
        key: 'customOptions.uploadActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !readOnly;'
      },
      {
        label: 'View Action Expression',
        key: 'customOptions.viewActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name;'
      },
      {
        label: 'Download Action Expression',
        key: 'customOptions.downloadActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name;'
      },
      {
        label: 'Delete Action Expression',
        key: 'customOptions.deleteActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name && !readOnly;'
      },
      {
        label: 'Replace Action Expression',
        key: 'customOptions.replaceActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name && row.status === \'deficient\' && !readOnly;'
      },
      {
        label: 'Mark Valid Action Expression',
        key: 'customOptions.markValidActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name && row.status !== \'validated\' && !readOnly;'
      },
      {
        label: 'Mark Deficient Action Expression',
        key: 'customOptions.markDeficientActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name && row.status !== \'deficient\' && !readOnly;'
      },
      {
        label: 'Mark Addressed Action Expression',
        key: 'customOptions.markAddressedActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name && row.status !== \'deficient\' && !readOnly;'
      },
      {
        label: 'View Deficiency Action Expression',
        key: 'customOptions.viewDeficiencyActionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 4,
        placeholder: 'Example: return !!row.file_name && row.status == \'deficient\' && !readOnly;'
      }
    ]
  },
  {
    label: 'Rule Source Configuration',
    key: 'rule_source_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Rule Stepper Id',
        key: 'customOptions.stepperId',
        type: 'textfield',
        input: true,
        tableView: true
      },
      {
        label: 'Rule Page Id',
        key: 'customOptions.pageId',
        type: 'textfield',
        input: true,
        tableView: true
      },
      {
        label: 'Rule Panel Key',
        key: 'customOptions.panelKey',
        type: 'textfield',
        input: true,
        tableView: true
      }
    ]
  },
  {
    label: 'Hide Upload Button Configuration',
    key: 'hide_upload_button_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Enable Hide Upload Button Condition',
        description: 'When checked, the upload button visibility is controlled by the expression below. If the expression returns true, the upload button is hidden. This setting is ignored when View Only Mode is enabled.',
        key: 'customOptions.hideUploadConditionEnabled',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Hide Upload Button Condition Expression',
        description: 'JavaScript expression that determines whether to hide the upload button. Available variables: data (form data), user (id, roleId, username), application (id, status), readOnly, documents, rules. Return true to hide, false to show.',
        key: 'customOptions.hideUploadConditionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 5,
        placeholder: 'Example: return user.roleId !== 405;'
      }
    ]
  },
  {
    label: 'View Only Mode',
    key: 'view_only_mode_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Show Only Available Documents',
        description: 'When checked, the grid fetches uploaded documents using only Application Id and Section (Panel Key); stepper/page scope is ignored. Only View and Download actions are shown.',
        key: 'customOptions.showOnlyAvailableDocuments',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Show Additional Upload Button',
        description: 'When checked along with Show Only Available Documents, an Upload button is displayed. The upload modal shows Category and Type options filtered by the current section. Uploaded documents will have View, Download, and Delete actions available.',
        key: 'customOptions.showAdditionalUploadInViewOnly',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Show Delete Button',
        description: 'When checked along with Show Only Available Documents, a Delete button is displayed for all documents. Users can delete any document in view-only mode.',
        key: 'customOptions.showDeleteButtonInViewOnly',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      }
    ]
  },
  {
    label: 'Show Only Configuration',
    key: 'show_only_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Enable Show Only Condition',
        description: 'When checked, the component visibility is controlled entirely by the expression below. If the expression returns false, the entire component is hidden regardless of rules, documents, or other logic.',
        key: 'customOptions.showOnlyConditionEnabled',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Show Only Condition Expression',
        description: 'JavaScript expression that determines whether the component is visible. Available variables: data (form data), user (id, roleId, username), application (id, status), readOnly, documents, rules. Must return true to show, false to hide.',
        key: 'customOptions.showOnlyConditionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 5,
        placeholder: 'Example: return user.roleId === 405;'
      }
    ]
  },
  {
    label: 'Show Only Category Configuration',
    key: 'show_only_category_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Enable Show Only Category Condition',
        description: 'When checked, documents belonging to the specified category are only visible to users who satisfy the condition expression. Users who do not satisfy the condition cannot see those documents regardless of upload status.',
        key: 'customOptions.showOnlyCategoryConditionEnabled',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Category Name / Key',
        description: 'The category name or key whose documents should be restricted. Must exactly match the category key configured in the document grid (e.g. the key from the categories list).',
        key: 'customOptions.showOnlyCategoryName',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: ProfileDocuments'
      },
      {
        label: 'Visibility Condition Expression',
        description: 'JavaScript expression returning true if the current user is allowed to see documents in the above category. Available variables: data (form data), user (id, roleId, username), application (id, status), readOnly, documents, rules. Return true to show, false to hide.',
        key: 'customOptions.showOnlyCategoryConditionExpression',
        type: 'textarea',
        input: true,
        tableView: true,
        rows: 5,
        placeholder: 'Example: return user.roleId === 405;'
      }
    ]
  },
  {
    label: 'Dynamic Document Configuration',
    key: 'dynamic_document_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Is Dynamic Type Dropdown Needed',
        key: 'customOptions.isDynamicTypeDropdownNeeded',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Source Custom Grid Key',
        key: 'customOptions.dynamicDocumentSourceGridKey',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: statesGrid'
      },
      {
        label: 'Source Record Key Field',
        key: 'customOptions.dynamicDocumentSourceRecordKeyField',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: state_id or state'
      },
      {
        label: 'Source Document Type Field',
        key: 'customOptions.dynamicDocumentSourceTypeField',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Optional: field that contains the document type'
      },
      {
        label: 'Source Document Type Lookup Request Type',
        key: 'customOptions.dynamicDocumentSourceTypeLookupRequestType',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: STATE'
      }
    ]
  },
  {
    label: 'Additional Dynamic Type Configuration',
    key: 'additional_dynamic_type_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Is Additional Dynamic Type Needed',
        description: 'When checked, the component collects document type values from a specified grid field and shows them in the upload modal Type dropdown filtered by the selected category.',
        key: 'customOptions.isAdditionalDynamicTypeNeeded',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      },
      {
        label: 'Source Grid Key',
        description: 'The form data key of the grid/datagrid to read records from.',
        key: 'customOptions.additionalDynamicTypeSourceGridKey',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: licenseGrid'
      },
      {
        label: 'Source Field Name (Type Value)',
        description: 'The field within each grid row whose value will be used as the document type option.',
        key: 'customOptions.additionalDynamicTypeSourceFieldName',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: license_type'
      },
      {
        label: 'Category Field Name',
        description: 'The field within each grid row that maps to the document category. The collected type values will only appear when this category is selected in the upload modal.',
        key: 'customOptions.additionalDynamicTypeCategoryFieldName',
        type: 'textfield',
        input: true,
        tableView: true,
        placeholder: 'Example: category_name'
      }
    ]
  },
  {
    label: 'Case Document Configuration',
    key: 'case_document_configuration',
    type: 'panel',
    input: false,
    tableView: false,
    components: [
      {
        label: 'Enable Case Document Mode',
        description: 'When checked, all documents in this grid will always have their status set to "Case" (same color as Verified). The Mark Valid, Mark Deficient, and View Deficiency actions will be hidden, and reviewer verification is not required to proceed to the next page.',
        key: 'customOptions.caseDocEnabled',
        type: 'checkbox',
        input: true,
        tableView: true,
        defaultValue: false
      }
    ]
  }
);

const COMPONENT_OPTIONS: FormioCustomComponentInfo = {
  type: 'supportingDocumentGrid',
  selector: 'app-supporting-document-grid',
  group: 'advanced',
  title: 'Supporting Document Grid',
  icon: 'table',
  fieldOptions: ['value', 'form', 'description'],
  editForm: () => editForm
};



export function registerSupportingDocumentGridComponent(injector: Injector) {
  try {
    registerExternalCustomFormioComponents(COMPONENT_OPTIONS, SupportingDocumentGridComponent, injector);
    console.log('Supporting Document Grid registration done');
  } catch (error) {
    console.error('Error registering Supporting Document Grid component', error);
  }
}
